import _ from 'underscore';
import React, { useState, useCallback, useContext, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { LegacyDateSetting } from './legacy-date-setting';
import { getCurrentDate, validateDate as validateDateUtil } from './utils';

const LegacyDateSettingWithCustomValidation = ({
  validationProps, updateValidation, ...restProps
}) => {
  const { data: dataSettings } = validationProps;
  const i18n = useContext(I18nContext);
  const activity = useContext(ActivityContext);
  const currentDate = getCurrentDate();

  const [updatedDateSettings, setUpdatedDateSettings] = useState(dataSettings);

  const validateDate = useCallback(data => validateDateUtil(data, i18n), [i18n]);

  const onChange = useCallback((newData) => {
    const validationError = validateDate(newData);
    updateValidation(validationError, newData);

    if (activity) {
      activity.signal(`onLegacyDateSettingChange - ${JSON.stringify(newData)}`);
    }
  }, [validateDate, updateValidation, activity]);

  const dateSettingWithDefaultStartDate = useMemo(() => _.defaults(dataSettings, {
    StartDate: currentDate,
  }), [currentDate, dataSettings]);

  useEffect(() => {
    setUpdatedDateSettings(_.clone(dateSettingWithDefaultStartDate));
  }, [dateSettingWithDefaultStartDate]);

  return (
    <LegacyDateSetting
      level="campaign"
      onChange={onChange}
      data={updatedDateSettings}
      activityLogger={activity}
      {...restProps}
    />
  );
};

LegacyDateSettingWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({}),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  activity: PropTypes.shape({
    signal: PropTypes.func,
  }),
};

LegacyDateSettingWithCustomValidation.defaultProps = {
  activity: null,
};

export const ValidatedLegacyDateSetting = withError(withCustomValidation(LegacyDateSettingWithCustomValidation));
